import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { estatePlanningProfileSubpageMetaOverrideSet } from '../EstatePlanningProfileSubpage';

const EstatePlanningProfileSubpageBodyPicker = ({ resource }) => {
  return resource.withRelationship(
    fr.relationships.estatePlanningDiscount.name,
    () => (
      <MetaControl metaOverrideSet={estatePlanningProfileSubpageMetaOverrideSet} resource={resource} attrName={'bodyArray'} />
    ),
    () => <MetaControl metaOverrideSet={estatePlanningProfileSubpageMetaOverrideSet} resource={resource} attrName={'body'} />,
  );
};

EstatePlanningProfileSubpageBodyPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
EstatePlanningProfileSubpageBodyPicker.defaultProps = {
};

export default EstatePlanningProfileSubpageBodyPicker;
